module.exports = __webpack_public_path__ + "static/media/logo_uat.2cfc2de8.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/logo_uat.png
 ** module id = 611
 ** module chunks = 0
 **/